import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import BooksSubmitButton from '../../../../components/books/common/buttons/BooksSubmitButton';
import BooksLabeledContainer from '../../../../components/books/model1/BooksLabeledContainer';
import BooksSelectedDateTimeWithChange from '../../../../components/books/model1/BooksSelectedDateTimeWithChange';
import BooksTextInput, {
  TextInputType,
} from '../../../../components/books/model1/forms/BooksTextInput';
import BooksWaitingListAlert from '../../../../components/books/model1/texts/BooksWaitingListAlert';

import ErrorMessage from './InputBookingWaitingListErrorMessage';

import * as IBooks from '../../../../interfaces/merchants/resources/books';

import * as $ from './helper';

interface Props {
  postable: boolean;
  timeSlot: IBooks.TimeSlot;
  errors?: IBooks.WaitingListErrors;
  onAddToWaitingList: (
    timeSlot: IBooks.EventTimeSlot | undefined,
    lastName?: string,
    firstName?: string,
    email?: string,
    onReturnSelectDateTime?: () => void,
  ) => Promise<void>;
  onReturnSelectDateTime: () => void;
}

interface Control {
  submittable?: boolean;
}

interface State {
  lastName: string;
  firstName: string;
  email: string;
  control: Control;
}

class InputBookingWaitingList extends React.Component<
  Props & InjectedIntlProps,
  State
> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    const _state: State = {
      lastName: '',
      firstName: '',
      email: '',
      control: {},
    };
    this.state = {
      ..._state,
      control: this.createControl(_state),
    };
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { name, value },
    } = e;
    const changedState = $.changeObjectByNestedString(this.state, name, value);
    this.setState({
      ...changedState,
      control: this.createControl(changedState as State),
    });
  }

  private async handleSubmit() {
    const { timeSlot, onAddToWaitingList, onReturnSelectDateTime } = this.props;
    const { lastName, firstName, email } = this.state;

    await onAddToWaitingList(
      timeSlot,
      lastName,
      firstName,
      email,
      onReturnSelectDateTime,
    );
  }

  private createControl(state: State): Control {
    const { control } = state;
    control.submittable =
      $.getValueByNestedString(state, 'lastName') &&
      $.getValueByNestedString(state, 'firstName') &&
      $.getValueByNestedString(state, 'email');
    return control;
  }

  public render() {
    const {
      intl,
      timeSlot,
      errors,
      onReturnSelectDateTime,
      postable,
    } = this.props;
    const { submittable } = this.state.control;
    return (
      <div>
        <BooksWaitingListAlert termsUrl="/terms" />
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.selectedDateTime',
          })}
          paddingTop={true}
          contentsPadding={true}
        >
          <BooksSelectedDateTimeWithChange
            date={timeSlot.date}
            startTime={timeSlot.startTime}
            endTime={timeSlot.endTime}
            changeTarget={onReturnSelectDateTime}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.lastName',
          })}
          paddingTop={true}
        >
          <BooksTextInput
            type={TextInputType.Text}
            name={'lastName'}
            value={this.state.lastName}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.firstName',
          })}
        >
          <BooksTextInput
            type={TextInputType.Text}
            name={'firstName'}
            value={this.state.firstName}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.email',
          })}
        >
          <BooksTextInput
            type={TextInputType.Email}
            name={'email'}
            value={this.state.email}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <ErrorMessage errors={errors && errors.email} />
        <BooksSubmitButton
          type="button"
          onClick={this.handleSubmit}
          value={intl.formatMessage({ id: 'books.submitLabel.addWaitingList' })}
          disabled={!submittable || !postable}
          postable={postable}
        >
          {intl.formatMessage({ id: 'books.submitLabel.addWaitingList' })}
        </BooksSubmitButton>
      </div>
    );
  }
}

export default injectIntl(InputBookingWaitingList);
